import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = { class: "parent-task-plate__tip" }
const _hoisted_3 = ["textContent"]

import { TirPmSvg } from "tir-components";
import { ParentTaskModel } from "./models";
import { computed, PropType } from "vue";
import { ConnectIcon } from "tir-style-system/icons/outline";
import { RouterLink, useRouter } from "vue-router";

/**Маршруты */

export default /*#__PURE__*/_defineComponent({
  __name: 'parent-task-plate',
  props: {
  /**Информация о задаче */
  task: { type: Object as PropType<ParentTaskModel> },
  /**Короткий вариант отображения плашки */
  isShort: { type: Boolean },
},
  setup(__props) {

const props = __props;

const router = useRouter();

/**Параметры */


/**Задача валидна */
const validTask = computed(
  () => props.task?.QueueTaskId && !props.task?.QueueTaskId?.includes("00000"),
);
/**Id проекта */
const projectId = computed(() => router.currentRoute.value?.params?.projectId);
/**Путь к задаче */
const taskPath = computed(() => {
  if (!validTask.value) return "";
  return router.resolve({
    name: "task-detail",
    params: {
      taskId: props.task?.TaskId,
      projectId: projectId.value,
      namespaceId: props.task?.NamespaceId,
      queueId: props.task?.QueueTaskId || "",
    },
  });
});

return (_ctx: any,_cache: any) => {
  return (validTask.value)
    ? (_openBlock(), _createBlock(_unref(RouterLink), {
        key: 0,
        to: taskPath.value
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["parent-task-plate", { short: __props.isShort }])
          }, [
            _createVNode(_unref(TirPmSvg), {
              url: __props.task.IconUrl,
              class: "parent-task-plate__namespace-icon",
              color: __props.task.Color
            }, null, 8, ["url", "color"]),
            (__props.isShort)
              ? (_openBlock(), _createBlock(_unref(ConnectIcon), {
                  key: 0,
                  class: "parent-task-plate__icon"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              textContent: _toDisplayString(__props.task.TaskId),
              class: "parent-task-plate__code"
            }, null, 8, _hoisted_1),
            (!__props.isShort)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_unref(ConnectIcon), { class: "parent-task-plate__icon" }),
                    _createTextVNode(" Родительская задача ")
                  ]),
                  _createElementVNode("div", {
                    textContent: _toDisplayString(__props.task.Name),
                    class: "parent-task-plate__name"
                  }, null, 8, _hoisted_3)
                ], 64))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }, 8, ["to"]))
    : _createCommentVNode("", true)
}
}

})